// extracted by mini-css-extract-plugin
module.exports = {"page":"pY","account":"qY","pdp":"rY","cart":"sY","brand":"tY","cartModal":"uY","checkout":"vY"};